import {
  DOUBAN_ASIDE_CARD_STYLE,
  DOUBAN_ASIDE_CARD_TITLE_STYLE,
  DOUBAN_ASIDE_LINK_IN_SECTION_STYLE,
  DOUBAN_ASIDE_LINK_STYLE,
  STORAGE_KEY,
  type TransferData
} from '../../constants'
import { getUserOptions } from '../settings'
import { maybeDownloadCover } from '../../utils/download'
import { parseDoubanPage } from './parser'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

export function injectDoubanPortButton (): void {
  if (document.getElementById('port-to-sg-btn')) return

  const btn = document.createElement('a')
  btn.id = 'port-to-sg-btn'
  btn.innerHTML = 'Port to StoryGraph'
  btn.href = '#'
  const aside = document.querySelector('.aside')
  if (aside) {
    btn.style.cssText = DOUBAN_ASIDE_LINK_IN_SECTION_STYLE

    const wrapper = document.createElement('div')
    wrapper.id = 'port-to-sg-card'
    wrapper.style.cssText = DOUBAN_ASIDE_CARD_STYLE

    const title = document.createElement('h2')
    title.style.cssText = DOUBAN_ASIDE_CARD_TITLE_STYLE
    title.innerHTML = '<span>StoryGraph</span>&nbsp;·&nbsp;·&nbsp;·&nbsp;·&nbsp;·&nbsp;·&nbsp;'

    wrapper.appendChild(title)
    wrapper.appendChild(btn)
    aside.insertBefore(wrapper, aside.firstChild)
    window.setTimeout(() => {
      if (wrapper.parentElement === aside) {
        aside.insertBefore(wrapper, aside.firstChild)
      }
    }, 1200)
  } else {
    btn.style.cssText = DOUBAN_ASIDE_LINK_STYLE
    const h1 = document.querySelector('h1')
    if (!h1) return

    const clear = h1.querySelector('.clear')
    if (clear) {
      h1.insertBefore(btn, clear)
    } else {
      h1.appendChild(btn)
    }
  }

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseDoubanPage()
    const options = getUserOptions()

    if (options.downloadDoubanCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
